module.exports = __webpack_public_path__ + "static/home_blue@2x-3834f7e9d084b813d03ff2139e3b20a1.png";